import { render, staticRenderFns } from "./share-model.vue?vue&type=template&id=30c25ed2&scoped=true&"
import script from "./share-model.vue?vue&type=script&lang=ts&"
export * from "./share-model.vue?vue&type=script&lang=ts&"
import style0 from "./share-model.vue?vue&type=style&index=0&id=30c25ed2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c25ed2",
  null
  
)

export default component.exports